<template>
  <section class="navbar">
    <div class="account-info">
      <!-- <el-button type="primary" size="mini" @click="showEditAccount = true">个性化设置</el-button> -->
      <img
        class="user-logo"
        :src="brandAvatarSrc"
        alt=""
        @click="showEditAccount = true"
        @error="onBrandLogoError"
      />
      <div class="user-info">
        <p class="user-name">
          {{ 
            ($store.state.MerchantMe.merchantInfo && $store.state.MerchantMe.merchantInfo.shortName) || 
            ($store.state.MerchantMe.merchantInfo && $store.state.MerchantMe.merchantInfo.name) || 
            '加载中...' 
          }}
        </p>
        <!-- <p class="conact-phone">{{ contactPhone }}</p> -->
      </div>
    </div>

    <div v-show="fetchItem" class="download-icon">
      <el-popover placement="top-start" width="300" trigger="click">
        <div slot="reference">
          <el-progress type="circle" :width="29" :stroke-width="2" :show-text="false" :percentage="downloadProgress"></el-progress>
          <el-icon name="download"></el-icon>
        </div>
        <ul class="download-file-list">
          <li v-for="item in fetchList" :key="item.id">
            <div class="filename" :title="item.filename">{{ item.filename }}</div>
            <el-progress :percentage="item.progress"></el-progress>
            <div v-if="item.status == 'fetching'" class="download-size">{{ sizeTostr(item.loaded) }} / {{ sizeTostr(item.total) }}</div>
            <div v-else-if="item.status == 'waiting'" class="download-waiting">等待中...</div>
            <div v-else-if="item.status == 'complete'" class="download-complete">准备完成</div>
          </li>
        </ul>
      </el-popover>
    </div>
    <LanguageSelect />
    <!-- <el-button class="logout" type="info" size="small" @click="handleToMerchantHelp">帮助中心</el-button> -->
    <QrcodeDialog type="manager" />
    <QrcodeDialog type="apply" />
    <!--    <el-button class="bindAccount" type="info" size="small" @click="showOpenAccount = true">绑定账号</el-button>-->
    <!--    <el-button class="logout" type="info" size="small" @click="handleToMerchantHelp">帮助中心</el-button>-->
    <!--    <QrcodePopover class="right-btn" :url="mobileMerchantUrl" tips="移动商户端">-->
    <!--      <el-button slot="reference" type="info" plain size="small">-->
    <!--        <svg-icon icon-class="mobile-icon" style="margin-right: 4px"/>移动端</el-button>-->
    <!--    </QrcodePopover>-->
    <!--    <QrcodePopover class="right-btn" :url="mobileMerchantHomeUrl" tips="商户活动列表主页">-->
    <!--      <el-button slot="reference" type="info" plain size="small">-->
    <!--        <svg-icon icon-class="mobile-registration" style="margin-right: 4px"/>-->
    <!--        商户主页</el-button>-->
    <!--    </QrcodePopover>-->
    <el-dropdown @command="(v) => handleCommand(v)">
      <span class="el-dropdown-linkss">
        <el-avatar :src="brandAvatarSrc" />
        <i class="el-icon-arrow-down el-icon--right" />
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item :disabled="true" style="color: #8c939d" command="handleShowOpenAccount">{{ mobile }}</el-dropdown-item>
        <el-dropdown-item command="handleShowOpenAccount">
          <span>{{ $t('header.binding') }}</span>
        </el-dropdown-item>
        <el-dropdown-item command="logout">
          <span>{{ $t('header.logout') }}</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <!--    <el-button class="bindAccount" type="info" size="small" @click="showOpenAccount = true">绑定账号</el-button>-->
    <open-account v-model="showOpenAccount"></open-account>
    <!--    <el-button class="logout" type="info" size="small" @click="logout">退出</el-button>-->
    <edit-account-info v-model="showEditAccount" />
    <!--    <merchant-help-drawer v-model="showMerchantHelpDialog" title="帮助中心"></merchant-help-drawer>-->
  </section>
</template>

<script>
import EditAccountInfo from '@/components/EditAccountInfo.vue'
import OpenAccount from '@/views/system/components/open-account'
import { sizeTostr, xossprocess } from '@/libs/utils'
import MerchantHelpDrawer from '@/views/help/components/merchant-help-drawer'
import QrcodePopover from '@/components/QrcodePopover/index.vue'
import QrcodeDialog from '@/components/QrcodeDialog/index.vue'

export default {
  components: {
    LanguageSelect: () => import('@/components/Lang.vue'),
    EditAccountInfo,
    OpenAccount,
    MerchantHelpDrawer,
    QrcodePopover,
    QrcodeDialog
  },
  data() {
    return {
      showEditAccount: false,
      showOpenAccount: false,
      tx: require('@/assets/imgs/tx.png'),
      showMerchantHelpDialog: false,
      brandLogoBroken: false
    }
  },
  computed: {
    username() {
      return this.$store.state.MerchantMe.merchantInfo && this.$store.state.MerchantMe.merchantInfo.name
    },
    title() {
      const merchantInfo = this.$store.state.MerchantMe.merchantInfo
      // 确保返回字符串，避免返回 undefined
      if (merchantInfo) {
        // 优先使用 shortName
        if (merchantInfo.shortName) {
          return merchantInfo.shortName
        }
        // 如果没有 shortName，尝试使用 name
        if (merchantInfo.name) {
          return merchantInfo.name
        }
      }
      // 如果 merchantInfo 不存在或没有名称，返回 null（让模板显示"加载中..."）
      return null
    },
    displayTitle() {
      // 计算最终显示的标题
      const merchantInfo = this.$store.state.MerchantMe.merchantInfo
      
      // 如果 merchantInfo 存在且有 shortName，返回 shortName
      if (merchantInfo && merchantInfo.shortName) {
        return merchantInfo.shortName
      }
      
      // 如果 merchantInfo 存在但没有 shortName，尝试使用 name
      if (merchantInfo && merchantInfo.name) {
        return merchantInfo.name
      }
      
      // 如果 merchantInfo 不存在或没有名称，显示"加载中..."
      // 确保总是返回一个非空字符串
      return '加载中...'
    },
    contactPhone() {
      return this.$store.state.MerchantAuth.username
    },
    mobile() {
      return this.$store.state.MerchantAuth.mobile
    },
    fetchList() {
      return this.$store.state.Download.downloadList
    },
    fetchItem() {
      return this.$store.state.Download.downloadList.find((n) => n.status == 'fetching')
    },
    downloadProgress() {
      return this.fetchItem ? this.fetchItem.progress : 0
    },
    /** 商户品牌图（需 publicDataHost + 相对路径 或 已是绝对 URL）；否则不要用坏链占坑 */
    logo() {
      const m = this.$store.state.MerchantMe.merchantInfo
      const raw = m && m.merchantHomePage && m.merchantHomePage.brandIconUrl
      if (!raw) return null
      const processed = xossprocess(
        raw,
        'image/resize,w_72/rounded-corners,r_9/crop,w_72,h_72,g_center'
      )
      return processed || null
    },
    brandAvatarSrc() {
      if (this.brandLogoBroken) return this.tx
      return this.logo || this.tx
    },
    merchantInfo() {
      return this.$store.state.MerchantMe.merchantInfo
    }
  },
  watch: {
    // 监听 merchantInfo 变化，确保标题及时更新
    merchantInfo: {
      handler(newVal, oldVal) {
        // 无论是否变化，都强制更新一次，确保标题显示
        // 使用 setTimeout 确保在下一个事件循环更新
        setTimeout(() => {
          this.$forceUpdate()
        }, 0)
      },
      deep: true,
      immediate: true
    },
    // 同时监听路由变化，确保切换路由时也能更新
    '$route': {
      handler() {
        // 路由变化时，检查是否需要更新商户信息
        if (!this.$store.state.MerchantMe.merchantInfo) {
          this.$store.dispatch('MerchantMe/getMerchantInfo').then(() => {
            this.$nextTick(() => {
              this.$forceUpdate()
            })
          })
        }
      },
      immediate: false
    },
    // 监听 title 计算属性的变化，确保标题能正确显示
    title: {
      handler(newVal, oldVal) {
        // 无论 title 是否变化，都强制更新，确保标题显示
        setTimeout(() => {
          this.$forceUpdate()
        }, 0)
      },
      immediate: true
    },
    // 监听 displayTitle 的变化，确保标题能正确显示
    displayTitle: {
      handler(newVal, oldVal) {
        // 无论 displayTitle 是否变化，都强制更新
        setTimeout(() => {
          this.$forceUpdate()
        }, 0)
      },
      immediate: true
    },
    // 直接监听 store 中的 merchantInfo
    '$store.state.MerchantMe.merchantInfo': {
      handler(newVal, oldVal) {
        this.brandLogoBroken = false
        setTimeout(() => {
          this.$forceUpdate()
        }, 0)
      },
      deep: true,
      immediate: true
    }
  },
  async mounted() {
    // 组件挂载时，无论 merchantInfo 是否存在，都尝试获取最新数据
    // 这样可以确保切换账号后标题能正确显示
    try {
      const merchantInfo = await this.$store.dispatch('MerchantMe/getMerchantInfo')
      // 强制更新一次，确保标题显示
      setTimeout(() => {
        this.$forceUpdate()
      }, 0)
    } catch (error) {
      // 即使失败也强制更新，确保显示"加载中..."
      setTimeout(() => {
        this.$forceUpdate()
      }, 0)
    }
  },
  // 添加 activated 钩子，确保在 keep-alive 组件激活时也能更新
  async activated() {
    // 每次激活时都检查并更新商户信息
    try {
      if (!this.$store.state.MerchantMe.merchantInfo) {
        await this.$store.dispatch('MerchantMe/getMerchantInfo')
      }
      // 强制更新一次，确保标题显示
      setTimeout(() => {
        this.$forceUpdate()
      }, 0)
    } catch (error) {
      setTimeout(() => {
        this.$forceUpdate()
      }, 0)
    }
  },
  methods: {
    onBrandLogoError() {
      this.brandLogoBroken = true
    },
    handleCommand(funName) {
      if (this[funName]) {
        return this[funName]()
      }
    },
    handleShowOpenAccount() {
      this.showOpenAccount = true
    },
    sizeTostr,
    async logout() {
      let query = {
        redirect: `${this.$route.fullPath}`
      }
      // 如果有商户信息，添加到 query 中
      if (this.$store.state.MerchantMe.merchantInfo && this.$store.state.MerchantMe.merchantInfo.merchantId) {
        query.merchantId = this.$store.state.MerchantMe.merchantInfo.merchantId
      }
      // 登出清理本地信息
      await this.$store.dispatch('MerchantAuth/logout')
      // 使用 nextTick 确保 token 清除后再导航，避免与路由守卫冲突
      this.$nextTick(() => {
        // 跳转到登陆页面，使用 replace 避免导航冲突
        this.$router.replace({
          path: '/login',
          query
        }).catch(() => {
          // 忽略路由跳转冲突错误
        })
      })
    },
    handleToMerchantHelp() {
      this.showMerchantHelpDialog = true
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  min-height: 60px;
  background-color: #fff;
  padding: 11.4px 30px;
  box-shadow: 0px 4px 8px 1px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  color: #fff;
  gap: 10px;

  .qrcode-all {
    margin-left: 0;
  }

  .el-dropdown-linkss {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .el-dropdown-linkss:hover {
    cursor: pointer;
  }
  .el-icon-arrow-down {
    font-size: 16px;
  }

  .account-info {
    flex: 1;
    display: inline-flex;
    align-items: center;
    height: 100%;
  }

  p {
    margin: 0;
  }

  .user-logo {
    width: 36px;
    height: 36px;
  }

  .user-info {
    margin-left: 15px;
  }

  .user-name {
    font-size: 16px;
    color: rgba(47, 55, 66, 1);
  }

  .conact-phone {
    font-size: 15px;
    margin-top: 5px;
  }

  .logout {
    flex-shrink: 0;
  }

  .bindAccount {
    margin-right: 15px;
    margin-left: 10px;
  }

  .download-icon {
    margin-right: 15px;
    position: relative;

    .el-icon-download {
      position: absolute;
      left: 50%;
      top: 45%;
      transform: translate(-50%, -50%);
    }
  }

  .el-button--info {
    color: #687583;
    background-color: #f6f6f9;
    border-color: #f6f6f9;
  }
}
</style>
<style lang="scss">
.download-file-list {
  list-style: none;
  margin: 0;
  padding: 0;
  font-size: 14px;
  height: 50vh;
  overflow-y: auto;

  li + li {
    border-top: 1px solid #eee;
  }

  li:not(:last-child) {
    padding-bottom: 12px;
  }

  li:not(:first-child) {
    padding-top: 12px;
  }

  .filename {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .download-waiting {
    font-size: 12px;
  }

  .download-complete {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/NavcigationBar.vue